import { useState, useEffect } from "react";
import axios from "axios";
import css from "../index.module.css";
import { toast } from "sonner";
import useUserData from "@hooks/useUserData";

export default function Notifications() {
  const { refreshUserData } = useUserData();
  const [notifications, setNotifications] = useState<any>([]);

  useEffect(() => {
    axios.get(`${import.meta.env.VITE_API_URL}/user/notifications`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      })
      .then((response) => {
        setNotifications(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleReadNotification = (id: string) => {
    if (notifications.find((item: any) => item.id === id)?.isRead === 'READ') {
      return;
    }

    axios.post(`${import.meta.env.VITE_API_URL}/user/notifications/read`, { notificationId: id }, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
      },
    })
    .then((_) => {
      toast.success("Уведомление прочитано");
      refreshUserData();
      setNotifications(notifications.map((item: any) => item.id === id ? { ...item, isRead: 'READ' } : item));
    })
    .catch((_) => {
      toast.error("Ошибка прочтения уведомления");
    });
  };

  return (
    <div className={css.col1}>
        <div className={css.accountInfo}>
            <div className={css.notifications}>
                {notifications.map((item: any) => (
                    <div className={`${css.notification} ${item.isRead === 'READ' ? css.read : css.unread}`} key={item.id} onClick={() => handleReadNotification(item.id)}>
                    <h3>{item.title}</h3>
                    <p>{item.message}</p>
                    <span>{item.isRead === 'READ' ? 'Прочитано' : 'Не прочитано'} · {new Date(item.createdAt).toLocaleString("ru-RU")}</span>
                    </div>
                ))}

                {notifications.length <= 0 && (
                    <a style={{ fontSize: 18 }}>Уведомлений нет...</a>
                )}
            </div>
        </div>
    </div>
  );
}
